import { createSelector } from 'reselect'
import { b64ToBlob } from '../components/Common/imageCompressor'

const rubrosReducerDataSelector = state => state.rubrosReducer.getIn(["data"]).toJS()
export const rubrosDataSelector = createSelector(
    rubrosReducerDataSelector, (dataField) => {      
      return {
        rubros: (dataField.rubros && dataField.rubros.map)?dataField.rubros.map(x=>({...x, imagen:  b64ToBlob(x.imagen)})):dataField.rubros,
        subrubros: (dataField.subrubros && dataField.subrubros.map)?dataField.subrubros.map(x=>({...x, imagen: b64ToBlob(x.imagen)})):dataField.subrubros,
        superRubros: dataField.superRubros
      }
    } 
  )

  export const rubrosEditSelector = createSelector(
    rubrosReducerDataSelector, (dataField) => {
      return {
        rubro: {
           ...dataField.rubroEdit,
           imagen: (dataField.rubroEdit)&&b64ToBlob(dataField.rubroEdit.imagen), 
           imagenOriginal: (dataField.rubroEdit)&& b64ToBlob(dataField.rubroEdit.imagenOriginal )
        }
      }
    } 
  )

  export const subrubrosEditSelector = createSelector(
    rubrosReducerDataSelector, (dataField) => {
      /**cast image */
      return {/** se llama rubro para que sea compatible con la edicion de rubros y poder reutilizar */
        rubro: {
           ...dataField.subrubroEdit,
           imagen: (dataField.subrubroEdit)&&b64ToBlob(dataField.subrubroEdit.imagen), 
           imagenOriginal: (dataField.subrubroEdit)&&b64ToBlob(dataField.subrubroEdit.imagenOriginal) 
        }
      }
    } 
  )

const subrubrosPickinDataSelector = state => state.rubrosReducer.getIn(["data"]).toJS()
export const subrubrosPickingSelector = createSelector(
  subrubrosPickinDataSelector, (datafield) => {    
    return datafield.subrubrosPicking
  }
)
